export enum HotKey {
  CONVERSATION_UP = 'control.shift.arrowup',
  CONVERSATION_DOWN = 'control.shift.arrowdown',
  LOAD_CMS = 'control.shift.l',
  SEND_TO_CMS = 'control.shift.c',
  ESCALATE_CMS = 'control.shift.x',
  GO_TO_AI_ADVICE = 'control.shift.i',
}
